// Realistic placeholder data for BYD Indonesia lineup
// Prices in IDR (realistic market estimates 2025-2026)

export const MODELS = [
  {
    slug: "m6",
    name: "BYD M6",
    tagline: "MPV Listrik Keluarga",
    category: "MPV 7-Seater EV",
    featured: true,
    priority: 2,
    price: 379000000,
    priceLabel: "Mulai Rp 379 Juta",
    hero: "https://static.prod-images.emergentagent.com/jobs/52e05a9a-1ea1-4291-a4d0-ea12f34e831c/images/e788f852fcabe8747d038327e66e05b35b1b413c32795886630ff6c2b96d811b.png",
    thumb:
      "https://static.prod-images.emergentagent.com/jobs/52e05a9a-1ea1-4291-a4d0-ea12f34e831c/images/e788f852fcabe8747d038327e66e05b35b1b413c32795886630ff6c2b96d811b.png",
    colors: ["Crystal White", "Harbour Grey", "Cosmos Black"],
    stock: "Ready Stock",
    shortDesc:
      "MPV listrik 7-seater dengan Blade Battery, kabin lapang, dan efisiensi biaya operasional hingga 70% lebih hemat dibanding MPV bensin.",
    highlights: [
      { label: "Daya Jelajah", value: "420 km (NEDC)" },
      { label: "Baterai", value: "71.8 kWh Blade LFP" },
      { label: "Kursi", value: "7 Penumpang 2-3-2" },
      { label: "Fast Charging", value: "30-80% dalam 30 menit" },
    ],
    keyFeatures: [
      {
        title: "Kenyamanan Keluarga",
        desc: "Kursi kapten baris kedua dengan ventilated seat, ruang kaki terlapang di kelasnya, dan panoramic sunroof.",
      },
      {
        title: "Daya Jelajah Baterai",
        desc: "Blade Battery LFP 71.8 kWh memberikan jarak tempuh hingga 420 km - cukup untuk Jakarta-Bandung PP tanpa charging.",
      },
      {
        title: "Efisiensi Biaya Operasional",
        desc: "Biaya listrik hanya ±Rp 180/km vs bensin ±Rp 1.200/km. Hemat hingga Rp 20 juta per tahun.",
      },
    ],
    specs: {
      Powertrain: "Electric Motor 120 kW (163 HP)",
      Torque: "310 Nm",
      "0-100 km/h": "10.1 detik",
      "Top Speed": "160 km/h",
      Battery: "71.8 kWh Blade LFP",
      Range: "420 km (NEDC)",
      Charging: "AC 7kW / DC 80kW",
      Dimensi: "4.710 x 1.810 x 1.690 mm",
      Wheelbase: "2.800 mm",
      "Berat Kosong": "1.930 kg",
      Garansi: "8 tahun / 160.000 km (baterai)",
    },
  },
  {
    slug: "atto-1",
    name: "BYD Atto 1",
    tagline: "Hatchback Kompak Terlaris",
    category: "City EV Hatchback",
    featured: true,
    priority: 1,
    price: 195000000,
    priceLabel: "Mulai Rp 195 Juta",
    hero: "https://static.prod-images.emergentagent.com/jobs/52e05a9a-1ea1-4291-a4d0-ea12f34e831c/images/6145a7f8fda2110dea3adff5872504b7d120215821247c7892f7dd5dd0035e34.png",
    thumb:
      "https://static.prod-images.emergentagent.com/jobs/52e05a9a-1ea1-4291-a4d0-ea12f34e831c/images/6145a7f8fda2110dea3adff5872504b7d120215821247c7892f7dd5dd0035e34.png",
    colors: ["Apple Green", "Delicate Pink", "Pure White", "Space Black"],
    stock: "Ready Stock",
    shortDesc:
      "EV hatchback kompak paling terjangkau dengan biaya operasional Rp 150/km, cocok untuk harian kota dan komuter.",
    highlights: [
      { label: "Daya Jelajah", value: "340 km (NEDC)" },
      { label: "Baterai", value: "30.08 kWh Blade" },
      { label: "Konsumsi", value: "10.6 kWh/100km" },
      { label: "Fast Charging", value: "30-80% dalam 30 menit" },
    ],
    keyFeatures: [
      {
        title: "Ideal untuk Harian Kota",
        desc: "Dimensi kompak 3.780 mm dengan radius putar kecil, parkir mudah di gang sempit & mall.",
      },
      {
        title: "Efisiensi Terbaik di Kelasnya",
        desc: "Konsumsi hanya 10.6 kWh/100km - biaya per km sekitar Rp 150, 8x lebih hemat dari bensin.",
      },
      {
        title: "Blade Battery Aman",
        desc: "Baterai LFP tahan tusuk paku, garansi 8 tahun, tetap aman di iklim tropis Indonesia.",
      },
    ],
    specs: {
      Powertrain: "Electric Motor 55 kW (75 HP)",
      Torque: "135 Nm",
      "0-100 km/h": "14.0 detik",
      "Top Speed": "130 km/h",
      Battery: "30.08 kWh Blade LFP",
      Range: "340 km (NEDC)",
      Charging: "AC 6.6kW / DC 40kW",
      Dimensi: "3.780 x 1.715 x 1.570 mm",
      Wheelbase: "2.340 mm",
      "Berat Kosong": "1.165 kg",
      Garansi: "8 tahun / 160.000 km (baterai)",
    },
  },
  {
    slug: "seal",
    name: "BYD Seal",
    tagline: "Sport Sedan Performa Tinggi",
    category: "Performance Sedan EV",
    featured: false,
    priority: 3,
    price: 629000000,
    priceLabel: "Mulai Rp 629 Juta",
    hero: "https://images.unsplash.com/photo-1760435107985-40b6872c8c97?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    thumb:
      "https://images.unsplash.com/photo-1760435107985-40b6872c8c97?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    colors: ["Atlantis Grey", "Arctic Blue", "Aurora White"],
    stock: "Ready Stock",
    shortDesc:
      "Sedan sport elektrik bertenaga 530 HP dengan akselerasi 3.8 detik dan platform e-Platform 3.0 terbaru.",
    highlights: [
      { label: "Daya Jelajah", value: "580 km (CLTC)" },
      { label: "Baterai", value: "82.5 kWh CTB" },
      { label: "0-100", value: "3.8 detik" },
      { label: "Fast Charging", value: "150 kW DC" },
    ],
    keyFeatures: [
      {
        title: "Performa Supercar",
        desc: "AWD twin-motor 530 HP, akselerasi 0-100 km/h hanya 3.8 detik dengan launch control.",
      },
      {
        title: "Cell-to-Body Technology",
        desc: "Integrasi baterai dengan bodi meningkatkan rigiditas torsional 70% untuk handling presisi.",
      },
      {
        title: "iTAC & DiSus-C",
        desc: "Kontrol traksi pintar dan suspensi adaptif untuk kenyamanan dan stabilitas maksimal.",
      },
    ],
    specs: {
      Powertrain: "Dual Motor AWD 390 kW (530 HP)",
      Torque: "670 Nm",
      "0-100 km/h": "3.8 detik",
      "Top Speed": "180 km/h",
      Battery: "82.5 kWh Blade LFP CTB",
      Range: "580 km (CLTC)",
      Charging: "AC 11kW / DC 150kW",
      Dimensi: "4.800 x 1.875 x 1.460 mm",
      Wheelbase: "2.920 mm",
      "Berat Kosong": "2.185 kg",
      Garansi: "8 tahun / 160.000 km (baterai)",
    },
  },
  {
    slug: "atto-3",
    name: "BYD Atto 3",
    tagline: "SUV Listrik Serbaguna",
    category: "Compact SUV EV",
    featured: false,
    priority: 4,
    price: 515000000,
    priceLabel: "Mulai Rp 515 Juta",
    hero: "https://images.unsplash.com/photo-1678796107506-639fca898022?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    thumb:
      "https://images.unsplash.com/photo-1678796107506-639fca898022?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    colors: ["Surf Blue", "Ski White", "Parkour Red", "Boulder Grey"],
    stock: "Ready Stock",
    shortDesc:
      "SUV compact dengan interior futuristik, daya jelajah 480 km dan teknologi e-Platform 3.0.",
    highlights: [
      { label: "Daya Jelajah", value: "480 km (NEDC)" },
      { label: "Baterai", value: "60.48 kWh Blade" },
      { label: "Daya", value: "150 kW (204 HP)" },
      { label: "Fast Charging", value: "30-80% dalam 29 menit" },
    ],
    keyFeatures: [
      {
        title: "Desain Futuristik",
        desc: "Interior bergaya gym dengan steering roda mirip dumbell, rotating 12.8-inch screen.",
      },
      {
        title: "Ruang SUV Luas",
        desc: "Bagasi 440 L dan kabin lapang 5-seater untuk kenyamanan perjalanan keluarga.",
      },
      {
        title: "Heat Pump System",
        desc: "Sistem pompa panas efisien menjaga konsumsi baterai stabil di AC penuh.",
      },
    ],
    specs: {
      Powertrain: "Electric Motor 150 kW (204 HP)",
      Torque: "310 Nm",
      "0-100 km/h": "7.3 detik",
      "Top Speed": "160 km/h",
      Battery: "60.48 kWh Blade LFP",
      Range: "480 km (NEDC)",
      Charging: "AC 7kW / DC 80kW",
      Dimensi: "4.455 x 1.875 x 1.615 mm",
      Wheelbase: "2.720 mm",
      "Berat Kosong": "1.750 kg",
      Garansi: "8 tahun / 160.000 km (baterai)",
    },
  },
  {
    slug: "dolphin",
    name: "BYD Dolphin",
    tagline: "Hatchback Modern Stylish",
    category: "Urban Hatchback EV",
    featured: false,
    priority: 5,
    price: 425000000,
    priceLabel: "Mulai Rp 425 Juta",
    hero: "https://images.unsplash.com/photo-1639302610362-4c86747e8680?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    thumb:
      "https://images.unsplash.com/photo-1639302610362-4c86747e8680?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    colors: ["Ice Blue", "Coral Pink", "Sandstorm Grey", "Polar White"],
    stock: "Ready Stock",
    shortDesc:
      "Hatchback listrik lincah untuk perkotaan dengan desain Ocean Aesthetic yang segar.",
    highlights: [
      { label: "Daya Jelajah", value: "405 km (NEDC)" },
      { label: "Baterai", value: "44.9 kWh Blade" },
      { label: "Daya", value: "70 kW (95 HP)" },
      { label: "Fast Charging", value: "60 kW DC" },
    ],
    keyFeatures: [
      {
        title: "Ocean Design Language",
        desc: "Eksterior aerodinamis terinspirasi lumba-lumba dengan koefisien drag hanya 0.29.",
      },
      {
        title: "Hemat Biaya Harian",
        desc: "Biaya listrik sekitar Rp 170/km - sangat cocok untuk pemakaian komuter harian.",
      },
      {
        title: "DiLink 4.0",
        desc: "Infotainment 12.8-inch rotating display dengan konektivitas smartphone seamless.",
      },
    ],
    specs: {
      Powertrain: "Electric Motor 70 kW (95 HP)",
      Torque: "180 Nm",
      "0-100 km/h": "12.3 detik",
      "Top Speed": "150 km/h",
      Battery: "44.9 kWh Blade LFP",
      Range: "405 km (NEDC)",
      Charging: "AC 7kW / DC 60kW",
      Dimensi: "4.125 x 1.770 x 1.570 mm",
      Wheelbase: "2.700 mm",
      "Berat Kosong": "1.405 kg",
      Garansi: "8 tahun / 160.000 km (baterai)",
    },
  },
  {
    slug: "sealion-7",
    name: "BYD Sealion 7",
    tagline: "Performance SUV Coupe",
    category: "Mid-Size SUV EV",
    featured: false,
    priority: 6,
    price: 749000000,
    priceLabel: "Mulai Rp 749 Juta",
    hero: "https://images.unsplash.com/photo-1678796107506-639fca898022?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    thumb:
      "https://images.unsplash.com/photo-1678796107506-639fca898022?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    colors: ["Aurora White", "Atlantic Grey", "Shark Blue"],
    stock: "Indent - ETA 2 Minggu",
    shortDesc:
      "SUV coupe performa dengan dual motor AWD 530 HP, platform e-Platform 3.0 Evo.",
    highlights: [
      { label: "Daya Jelajah", value: "542 km (CLTC)" },
      { label: "Baterai", value: "82.5 kWh CTB" },
      { label: "0-100", value: "4.5 detik" },
      { label: "Fast Charging", value: "150 kW DC" },
    ],
    keyFeatures: [
      {
        title: "AWD Performa",
        desc: "Dual motor 390 kW dengan iTAC untuk traksi optimal di segala kondisi jalan.",
      },
      {
        title: "Desain Coupe SUV",
        desc: "Siluet sporty dengan aerodinamika premium dan panoramic glass roof.",
      },
      {
        title: "DiSus-C Intelligent Suspension",
        desc: "Suspensi pintar adaptif untuk kenyamanan dan handling di semua medan.",
      },
    ],
    specs: {
      Powertrain: "Dual Motor AWD 390 kW (530 HP)",
      Torque: "690 Nm",
      "0-100 km/h": "4.5 detik",
      "Top Speed": "215 km/h",
      Battery: "82.5 kWh Blade LFP CTB",
      Range: "542 km (CLTC)",
      Charging: "AC 11kW / DC 150kW",
      Dimensi: "4.830 x 1.925 x 1.620 mm",
      Wheelbase: "2.930 mm",
      "Berat Kosong": "2.340 kg",
      Garansi: "8 tahun / 160.000 km (baterai)",
    },
  },
  {
    slug: "denza-d9",
    name: "Denza D9",
    tagline: "Luxury MPV Flagship",
    category: "Premium MPV EV",
    featured: false,
    priority: 7,
    price: 1500000000,
    priceLabel: "Mulai Rp 1.5 Milyar",
    hero: "https://images.unsplash.com/photo-1678796107506-639fca898022?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    thumb:
      "https://images.unsplash.com/photo-1678796107506-639fca898022?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    colors: ["Obsidian Black", "Pearl White", "Sapphire Blue"],
    stock: "Indent - ETA 4 Minggu",
    shortDesc:
      "MPV mewah flagship BYD-Mercedes Benz joint venture dengan kursi eksekutif premium.",
    highlights: [
      { label: "Daya Jelajah", value: "600 km (CLTC)" },
      { label: "Baterai", value: "103.36 kWh" },
      { label: "Kursi", value: "7 Seat Eksekutif" },
      { label: "Fast Charging", value: "166 kW DC" },
    ],
    keyFeatures: [
      {
        title: "Kursi Eksekutif Premium",
        desc: "Kursi kapten baris kedua dengan massage, heating/ventilated, dan zero-gravity mode.",
      },
      {
        title: "Kabin Mewah Silent",
        desc: "Acoustic glass, Nappa leather, dan 16-speaker Dynaudio premium sound system.",
      },
      {
        title: "ADAS Level 2+",
        desc: "Adaptive cruise, lane keep, automatic parking, dan night vision camera.",
      },
    ],
    specs: {
      Powertrain: "Dual Motor AWD 280 kW (380 HP)",
      Torque: "480 Nm",
      "0-100 km/h": "6.9 detik",
      "Top Speed": "190 km/h",
      Battery: "103.36 kWh Blade LFP",
      Range: "600 km (CLTC)",
      Charging: "AC 11kW / DC 166kW",
      Dimensi: "5.250 x 1.960 x 1.920 mm",
      Wheelbase: "3.110 mm",
      "Berat Kosong": "2.760 kg",
      Garansi: "8 tahun / 160.000 km (baterai)",
    },
  },
];

export const getModelBySlug = (slug) => MODELS.find((m) => m.slug === slug);
export const getFeaturedModels = () =>
  MODELS.filter((m) => m.featured).sort((a, b) => a.priority - b.priority);

export const DEFAULT_FAQ = [
  {
    q: "Bagaimana cara charging BYD di rumah?",
    a: "BYD bisa dicharge melalui stop kontak standar PLN (mode trickle charge) atau menggunakan Wallbox 7 kW yang kami sediakan gratis untuk pembelian unit baru. Instalasi Wallbox di rumah selesai dalam 1-2 hari, butuh jalur listrik khusus 32A. Tim kami akan survei lokasi rumah Anda tanpa biaya.",
  },
  {
    q: "Berapa lama charging penuh di rumah?",
    a: "Menggunakan Wallbox 7 kW AC, charging 0-100% memakan waktu 6-10 jam tergantung kapasitas baterai. Sangat ideal untuk di-charge semalaman. Biaya listrik hanya sekitar Rp 200-400 per charging penuh dengan tarif PLN subsidi EV.",
  },
  {
    q: "Bagaimana garansi baterai BYD?",
    a: "Semua unit BYD dilengkapi Garansi Baterai 8 Tahun atau 160.000 km (mana tercapai dahulu). Blade Battery LFP tahan lebih dari 3.000 siklus pengisian, terbukti lolos uji tusuk paku tanpa terbakar. Garansi mencakup penurunan kapasitas di bawah 70%.",
  },
  {
    q: "Apakah aman charging saat hujan?",
    a: "Ya, sangat aman. Port charging BYD memiliki rating IP67 (tahan air dan debu). Sistem pengisian daya memiliki multi-layer protection yang otomatis memutus arus jika ada kebocoran listrik. Anda bisa charging di carport terbuka saat hujan dengan tenang.",
  },
  {
    q: "Apa saja biaya operasional BYD per bulan?",
    a: "Rata-rata pemilik BYD menghabiskan Rp 300.000-600.000/bulan untuk listrik (pemakaian 1.500 km). Service berkala setiap 20.000 km sekitar Rp 500.000-800.000 (jauh lebih murah dari mobil bensin). Tidak ada oli mesin, filter, atau busi yang perlu diganti.",
  },
  {
    q: "Bagaimana jika mogok/baterai habis di jalan?",
    a: "BYD Haka Auto Cibubur menyediakan Emergency Roadside Assistance 24 jam gratis selama 3 tahun pertama. Tim kami akan datang dengan mobile charger atau towing unit. Jaringan fast charging PLN Icon+ dan BYD Supercharger tersebar di jalur Jabodetabek.",
  },
];
